export default class KnockoutExtensions {
    public static createNullableChildObject(options: any): any {
        return !options.data ? null : ko.mapping.fromJS(options.data);
    }
}